import { render, staticRenderFns } from "./SentryTest.vue?vue&type=template&id=53ca4e22&"
import script from "./SentryTest.vue?vue&type=script&lang=js&"
export * from "./SentryTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports